export default __webpack_public_path__ + "static/media/addIconGray.ba7ca29b.svg";